

$(document).ready(function () {
    let bodyShouldBeScrollable = true;
    $(".dc_background").hide();
    $(".dc_how_background").hide();

    var scrollableDrawer = document.querySelector('#drawer-scrollable-menu');

    /**
     * In some cases we want the mobile menu to be white, but desktop transparent.
     */
    if (isMobile() && !shouldMobileHeaderBeTransparent()) {
        $('#header').removeClass('header--transparent');
        $('#header').attr('data-transparent-header', 'false');
    }
    headerTransparentToggle();

    function scrollbarWidth() { var a, b, c; if (c === undefined) { a = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'); b = a.children(); c = b.innerWidth() - b.height(99).innerWidth(); a.remove() } return c };

    function shouldMobileHeaderBeTransparent() {
        return $('#header').hasClass('header--mobile--transparent');
    }

    function headerTransparentToggle() {
        // If black font is desired leave it black
        if ($('#header').hasClass('header--transparent')
            && !$('#header').hasClass('header--black-font')) {
            switchToWhiteIcons();
        } else {
            switchToBlackIcons();
        }
    }

    function isMegaNavigationVisible() {
        return $("ul.mega-navigation").is(":visible");
    }

    function isSearchMenuVisible() {
        // If style is block then search is visible
        return $('.quick-search').hasClass("is-active");
    }

    function shouldHeaderBeTransparent() {
        return $(window).scrollTop() === 0 && $("#header").attr('data-transparent-header') == 'true';
    }

    function enableScroll() {
        $("body").css("overflow", "hidden visible");
        $("body").css("position", "static");
        showDarkCover(false);
        bodyShouldBeScrollable = true;
        // To counteract the scroll bar on the right
        $("#header").css("padding-right", "");
        $("#shopify-section-static-announcement-bar").css("padding-right", "");
    }

    function disableScroll() {
        $("body").css("overflow", "hidden hidden");
        $("body").css("height", "100%");
        $("body").css("position", "fixed");
        showDarkCover(true);
        bodyShouldBeScrollable = false;
        // To counteract the scroll bar on the right
        $("#header").css("padding-right", scrollbarWidth());
        $("#shopify-section-static-announcement-bar").css("padding-right", scrollbarWidth());
    }

    function showDarkCover(show) {
        if (show) {
            $('div.dark-cover').addClass("css-darknes");
        } else {
            $('div.dark-cover').removeClass("css-darknes");
        }
    }

    function closeMegaNav() {
        $('a.nav__menu--active').removeClass("nav__menu--active");
        $('div.nav__meganav.visible').removeClass("visible");
    }

    function closeDrawer() {
        $('.drawer-menu').removeClass("active");
        $('.drawer-menu').removeClass("visible");

        // Enable scroll back
        bodyScrollLock.enableBodyScroll(scrollableDrawer);
        bodyScrollLock.clearAllBodyScrollLocks();
    }

    function closeSearch() {
        $('.quick-search').removeClass("is-active");
        $('.search__input').val("");
        document.querySelector('.predictive-search-results').innerHTML = "";
    }

    function isMobile() {
        return $(document).width() <= 960;
    }

    function openSearch() {
        closeMegaNav();
        disableScroll();
        makeHeaderTransparent(false);
    }

    function closeAll() {
        closeMegaNav();
        closeSearch();
        enableScroll();
        makeHeaderTransparent(true);
    }

    function makeHeaderTransparent(enable) {
        if (enable) {
            if (shouldHeaderBeTransparent()) {
                $('#header').addClass('header--transparent');
            }
        } else {
            $('#header').removeClass('header--transparent');
        }
        headerTransparentToggle();
    }

    function switchToBlackIcons() {
        $('.dc_svg_white').css('display', 'none');
        $('.dc_svg_black').css('display', 'block');
        $('.logo-white').css('display', 'none');
        $('.logo-black').css('display', 'block');
    }

    function switchToWhiteIcons() {
        $('.dc_svg_black').css('display', 'none');
        $('.dc_svg_white').css('display', 'block');
        $('.logo-black').css('display', 'none');
        $('.logo-white').css('display', 'block');
    }

    function isHeaderTransparent() {
        return $('#header').hasClass('header--transparent');
    }

    function isDarkCoverVisible() {
        return $('div.dark-cover').hasClass('css-darknes');
    }

    function isHomePage() {
        return window.location.pathname === '/' || window.location.pathname === '/de' || window.location.pathname === '/en';
    }

    let lastIndex = -1;
    setInterval(function () {
        if (bodyShouldBeScrollable && $('body').attr("style") && $('body').attr("style").indexOf('hidden') != -1) {
            enableScroll();
        }
        if (!isHomePage()) {
            return;
        }

        if (!isHeaderTransparent() || isDarkCoverVisible()) {
            $('#header').removeClass('header--black-font');
            // In case the header is again made transparent, reset the interval last saved position
            lastIndex = -1;
            return;
        }

        // The first slider option should be in black instead of white
        const currentIndex = $('.slideshow__slide.is-selected').attr('data-index');
        // If no change no need to update styles
        if (currentIndex == lastIndex) {
            return;
        }
        if (currentIndex == -1) {//set 0 to get option back
            $('#header').addClass('header--black-font');
            $('.announcement-bar').addClass('white-announcement-bar');
            switchToBlackIcons();
        } else {
            $('#header').removeClass('header--black-font');
            $('.announcement-bar').removeClass('white-announcement-bar');
            switchToWhiteIcons();
        }
        lastIndex = currentIndex;
    }, 50);

    let lastScroll = -1;
    $(window).scroll(function () {
        const currentScroll = window.scrollY;
        if (currentScroll == lastScroll) {
            return;
        }
        let showMenu = false;
        // 22px is the top announcement bar
        if (currentScroll > 22) {
            // On non-homepage urls we need to add offset when hiding menu,
            // because there is no carousel with 100% height, same with header-image templates
            if (!isHomePage() && $('.static-new-page-header-image').length <= 0
                && $('#bg-full-image').length <= 0) {
                $("header").addClass('hidden-submenu-offset');
            }

            $("#header")
                // Make the header fixed
                .css("position", "fixed")
                .css("width", "100%")
                .css("top", "0")
                // Make it non transparent
                .removeClass("header--transparent");
            // In case user is Up-scroll then show menu also
            showMenu = currentScroll <= lastScroll;
        } else {
            $("header").removeClass('hidden-submenu-offset');
            $("#header")
                .css("position", "relative");
            if ($("#header").attr('data-transparent-header') == 'true'
                && !isMegaNavigationVisible() && !isSearchMenuVisible()) {
                $("#header").addClass("header--transparent");
            }
            showMenu = true
        }
        if (showMenu) {
            $("#navigation-menu")
                .css("transition", "height 0ms 0ms, opacity 600ms 0ms")
                .css("opacity", 1)
                .css("height", "auto");
        } else {
            $("#navigation-menu")
                .css("transition", "height 0ms 400ms, opacity 400ms 0ms")
                .css("opacity", 0)
                .css("height", 0)
                .css("overflow-y", "hidden");
        }
        lastScroll = currentScroll;

        headerTransparentToggle();
    });

    $('script[src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=WJB6TH&amp;shop=itiql.com.myshopify.com"]').remove()
    //jdocument.querySelector('script[src*="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=WNiUSc&amp;shop=itiql.com.myshopify.com"]').remove();

    /*ON-52 annnce bar link on  click*/
    $(".announcement-bar__content:contains('CLICK HERE')").html(function (_, html) {
        return html.replace(/(CLICK HERE)/g, '<span class="underline dc-trigger">$1</span>');
    });

    // Store the window width
    var windowWidth = $(window).width();
    $(window).resize(function (e) {
        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {
            // Update the window width for next time
            windowWidth = $(window).width();

            closeAll();
            closeDrawer();
        }
    });

    $('.nav__link').click(function (e) {
        window.open($(e.target).attr('href'), "_self");
    });

    // When drawer is closed
    $('.close-v2-icon-svg, .drawer-menu__overlay').click(function (e) {
        enableScroll();
        closeDrawer();
    });

    // When main menu item is hovered
    $('.nav__link.nav__link-parent, .header__nav').mouseenter(function (e) {
        if (!isMegaNavigationVisible()) {
            makeHeaderTransparent(false);
            disableScroll();
            closeSearch();
        }
        // Un-show previous menu
        $('.nav__link').removeClass('nav__menu--active');
        $('.nav__link').siblings('.nav__submenu.nav__meganav').removeClass('visible');
        // Show the menu of the item clicked, fallback to first
        let menuItem = $(e.target);
        if (!menuItem.hasClass('nav__link-parent')) {
            menuItem = menuItem.find('.nav__link.nav__link-parent').first();
        }

        menuItem.addClass('nav__menu--active');
        menuItem.siblings('.nav__submenu.nav__meganav').addClass('visible');
    });

    // When discover now link is clicked
    $('a#new-arrivals-link').click(function (e) {
        let activeMenu = $('.nav__menu--active');
        let link = '';
        switch (activeMenu.text()) {
            case 'WOMEN':
                link = '/collections/new-arrivals-women';
                break;
            case 'MEN':
                link = '/collections/men-new-arrivals';
                break;
            case 'HOME':
                link = '/collections/new-arrivals-home-decor';
                break;
            default:
                link = '/collections/new-arrivals';
                break;
        }
        window.open(link, "_self");
    });

    // When the cursor moves out of the meganav
    $('.nav__submenu.nav__meganav').mouseleave(function (e) {
        if ($(e.target).attr("class") && ($(e.target).attr("class").indexOf('nav__link') != -1
            || $(e.target).attr("class").indexOf('nav__submenu') != -1)) {
            return;
        }
        closeAll();
    });

    // Close meganav if menu with icons is hovered
    $('#icon-navigation').mouseenter(function (e) {
        if (isMegaNavigationVisible()) {
            closeAll();
        }
    });

    // In case the dark part ic clicked enable scroll back and close active stuff
    $('div.dark-cover').click(function () {
        closeAll();
    });

    // When drawer is opened
    $('.menu-icon-svg, .menu-icon-svg-div').click(function () {
        document.body.classList.add("trusbadge-hidden");
        closeAll();
        bodyScrollLock.disableBodyScroll(scrollableDrawer);
        showDarkCover(true);
        disableScroll();
    });

    // When drawer is closed
    $('.drawer-menu__close').click(function() {
        document.body.classList.remove("trusbadge-hidden");
    })

    // When search is opened from drawer menu
    $('#drawer-search-button').click(function () {
        enableScroll();
        $('.drawer-menu__overlay').trigger('click');
        openSearch();
    });

    // Mobile issue: when product group is opened through drawer enable scroll
    $('a.drawer-menu__link:not(.no-transition)').click(function () {
        enableScroll();
        $('.drawer-menu__overlay').trigger('click');
    });

    // When quick cart is pressed
    $('.cart-header-icon, div.quick-cart__indicator.js-cart-count, .cart-header-icon').click(function () {
        closeAll();
        disableScroll();
    });

    // Closing all
    $('.quick-cart__overlay,' +
        '.quick-cart__close,' +
        '.drawer-menu__overlay,' +
        '.close-icon-svg,' +
        '.close-v2-icon-svg').click(function () {
            enableScroll();
        });

    let currentLanguageScroll = $('.drawer-menu__panel').scrollTop();
    $('.drawer-menu-language').click(function () {
        if ($('#localization_form .drawer-menu__list--sub').hasClass('visible')) {
            currentLanguageScroll = $('.drawer-menu__panel').scrollTop();
            $('.drawer-menu__all-links').addClass('hide-element');
            $('.drawer-menu__list--sub:not(.drawer-menu__language)').addClass('hide-element');
            document.querySelector('.drawer-menu__panel').scrollTop = 263;
        } else {
            document.querySelector('.drawer-menu__panel').scrollTop = currentLanguageScroll;
            $('.drawer-menu__all-links').removeClass('hide-element');
            $('.drawer-menu__list--sub:not(.drawer-menu__language)').removeClass('hide-element');
        }
    });

    // When search is opened (since this is another plugin we need to do some stuff manually)
    $('.search-icon-img, .quick-search__trigger .icon-text').click(function () {
        openSearch();
    });

    // When membership or language dropdown is open close everything else
    $('.dc_modal_trigger, .language-top-icon-button').click(function () {
        closeAll();
    });

    var acc = document.getElementsByClassName("dc_accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("dc_active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

});

/* Handler for adding product to a cart - so we update also minicart */
function dcCartUpdatedHandler(e, er) {
    updateMembership(e.cart, er);
    validateCart(e.cart, er);
    refreshDcPopup();
}

/*ON-55*/
/* Modify langify modal*/
let setLangifyModalTitle = function () {
    var modalClassName = document.getElementsByClassName("ly-popup-modal-content");
    if (modalClassName) {
        for (var i = 0; i < modalClassName.length; i++) {
            collection = modalClassName[i].children;
            modalClassName[i].style.width = '412px'
            for (let i = 0; i < collection.length; i++) {
                if (collection[i].tagName === 'H3') {
                    setLangifyModalTitleH3(collection[i]);
                }
                if (collection[i].tagName === 'UL') {
                    setLanguageNames(collection[i]);
                }
            }
        }
    }
}
let setLanguageNames = function (ul) {
    const lang = new Map([["en", " ENGLISH"], ["de", " DEUTSCH"], ["it", " ITALIAN"], ["fr", " FRENCH"]]);
    for (let j = 0; j < ul.children.length; j++) {
        for (let key of lang.keys()) {
            if (ul.children[j].getAttribute("key") === key) {
                ul.children[j].firstChild.innerText = lang.get(key)
            }
        }
    }
}
let setLangifyModalTitleH3 = function (h3) {
    const domainSVG = "<img style='vertical-align: text-top;' width='16px' src='https://cdn.shopify.com/s/files/1/0591/2441/6663/t/3/assets/etiql_lang_icon.svg?v=2081191848346984923'/>"
    h3.innerHTML = ' &nbsp; &nbsp; &nbsp;' + domainSVG + ' &nbsp; ' + 'CHANGE LANGUAGE'
    const hr = document.createElement('hr');
    h3.appendChild(hr)
    hr.style.borderWidth = '1px'
    hr.style.borderColor = 'rgb(251, 251, 252)';
}

function getClass() {
    setLangifyModalTitle();
    const classname = document.getElementsByClassName("current_lang");
    if (classname) {
        for (let i = 0; i < classname.length; i++) {
            classname[i].innerHTML = "<img width='18px' src='https://cdn.shopify.com/s/files/1/0591/2441/6663/files/Etiql_icon-popup_language.png?v=1638351642'/>" + classname[i].innerHTML;
        }
    }
}
document.addEventListener("DOMContentLoaded", getClass);
/**/

/*
$(document).ready(function () {
    $(".tooltip").hover(function () {
        console.log("jujj");
        var divWidth = $(this).parent().width();
        divWidth = divWidth - 10;
        $(".tooltiptext").css('width', divWidth + 'px');
    })
});
*/
/*
$(document).ready(function () {
    $('.tooltip').mouseover(function (event) {

        var left = event.pageX - $(this).position().left;
        var top = event.pageY - $(this).position().bottom;
        $('#dc_tooltiptext').css({ top: top, left: left }).show();
        console.log(left, top);
        $('.tooltip').css('cursor', 'pointer');

    });

    $('.tooltip').mouseout(function () {
        setTimeout(function () {
            $('#dc_tooltiptext').hide();
        }, 600);
    });
});
*/

$(document).ready(function () {

    /*ON-90 favicon dark mode*/
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        //console.log("detect:dark");
        $("#favicon").attr("href", "https://cdn.shopify.com/s/files/1/0591/2441/6663/files/Etiql_favicon_New_white.png?v=1662637998");
    }
    else {
        //console.log("detect:light");
        $("#favicon").attr("href", "https://cdn.shopify.com/s/files/1/0591/2441/6663/files/Etiql_favicon_New_f283a9f2-ff4b-405a-8280-fb15cb8923f8.png?v=1662637999");

    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
        const newColorScheme = event.matches ? "dark" : "light";
        //console.log(newColorScheme);
        if (newColorScheme === "dark") {
            //console.log("detect update :dark");
            $("#favicon").attr("href", "https://cdn.shopify.com/s/files/1/0591/2441/6663/files/Etiql_favicon_New_white.png?v=1662637998");
        }
        else {
            //console.log("detect update:light");
            $("#favicon").attr("href", "https://cdn.shopify.com/s/files/1/0591/2441/6663/files/Etiql_favicon_New_f283a9f2-ff4b-405a-8280-fb15cb8923f8.png?v=1662637999");

        }

    });
    /**/

    function doHover() {
        $('.tooltip').hover(
            function () {
                //console.log("hover in");
                if ($('#dc_tooltiptext').is(":hidden")) {
                    var left_after = $(this).offset().left + 2;

                    //15px is expand touch area
                    var top_after = $(this).offset().top - $('#dc_tooltiptext-after').outerHeight() - 3 + 15;

                    var left = $(this).offset().left - 52 + 15;
                    var top = $(this).offset().top - $('#dc_tooltiptext').outerHeight() - $('#dc_tooltiptext-after').outerHeight() + 5 - 29 + 44;
                    var diff = left + $('#dc_tooltiptext').outerWidth() - window.innerWidth;
                    if (diff > 0) {
                        left = $(this).offset().left - diff - 70 + 15;
                        //console.log("out of screen");
                    }
                    $('#dc_tooltiptext').css({ top: top - 10, left: left }).show();
                    $('#dc_tooltiptext-after').css({ top: top_after - 10, left: left_after }).show();
                    //console.log(left, top, $(this).outerHeight());
                    $('.tooltip').css('cursor', 'pointer');
                    //console.log($('#dc_tooltiptext').offset());
                };
            },
            function () {
                $('#dc_tooltiptext').hide();
                $('#dc_tooltiptext-after').hide();
                //console.log("hover out");
            });

    }


    setTimeout(function () {
        doHover();
    }, 600);


    document.addEventListener('touchmove', function (e) {
        e.preventDefault();
        var touch = e.touches[0];
        //console.log(touch.pageX + " - " + touch.pageY);
        if ($('#dc_tooltiptext').is(":visible")) {
            $('.tooltip').mouseleave();
        };
    }, false);

    $(document).scroll(function () {
        if ($('#dc_tooltiptext').is(":visible")) {
            //            $('#dc_tooltiptext').hide();
            $('.tooltip').mouseleave();
        };
    });

    $(document).click(function () {
        setTimeout(function () {
            doHover();
        }, 600);

    });

});

/*
$(document).ready(function() {
  const eTrustedBadge = document.getElementById("trustbadge-container-98e3dadd90eb493088abdc5597a70810");
  let isTriggered = false; 

  document.addEventListener('scroll', handleScroll());
  console.log("listening");
                            
  function handleScroll() {
    if(!isTriggered) {
      eTrustedBadge.classList.add("disabled");
      isTriggered = true;

      console.log("stop listening");
      document.removeEventListener('scroll', handleScroll());
    }
  }

  setTimeout(function() {
    if(!isTriggered) {
      isTriggered = true;
      eTrustedBadge.classList.add("disabled");
    }
  }, 5000)
});*/

document.addEventListener("DOMContentLoaded", function() {
    function setHeaderHeight() {
        let headerEl = document.querySelector("#header");
        let headerElHeight = headerEl.getBoundingClientRect().height + "px";

        document.body.style.setProperty('--header-height', headerElHeight);
    }

    setHeaderHeight();
});
